<template>
  <i-container class="_align-self:stretch" am-sing-in>
    <i-row am-sing-in-row around middle>
      <i-column lg="4" md="6" sm="7">

        <i-card>
          <template #header>Sign in</template>

          <i-form @submit="onSubmit" v-model="form">
            <i-form-group>
              <i-form-label>Login</i-form-label>
              <i-input name="email" />
              <div am-error-field>
                <i-form-error for="email" />
              </div>
            </i-form-group>
            <i-form-group>
              <i-form-label>Password</i-form-label>
              <i-input type="password" name="password" autocomplete="off" />
              <div am-error-field>
                <i-form-error for="password" />
              </div>
            </i-form-group>
            <i-form-group>
              <i-button
                class="_width:100%"
                type="submit"
                :loading="loading"
                :disabled="form.invalid"
                :color="form.invalid ? '' : 'primary'"
              >
                Log in
              </i-button>
            </i-form-group>
          </i-form>

        </i-card>

      </i-column>
    </i-row>
  </i-container>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'SignInView',
  data () {
    return {
      loading: false,
      form: this.$inkline.form({
        email: {
          validators: [
            { name: 'required' },
            { name: 'email' }
          ]
        },
        password: {
          validators: [
            { name: 'required' },
            { name: 'minLength', value: 8 }
          ]
        }
      })
    }
  },
  methods: {
    ...mapMutations('notifications', ['addNotification']),
    onSubmit () {
      this.loading = true
      const user = {
        email: this.form.email.value,
        password: this.form.password.value
      }
      this.$store.dispatch('login', user)
        .then(() => {
          this.loading = false

          this.$router.push('/wear-select')
          this.addNotification({
            notification: {
              type: 'success',
              message: 'Logged in'
            }
          })
        })
        .catch(err => {
          this.loading = false

          const notification = { type: 'danger', message: null }
          if (err.body.errors) {
            for (const key in err.body.errors) {
              err.body.errors[key].forEach(el => {
                notification.message = el
                this.addNotification({ notification })
              })
            }
          } else {
            if (err.info.status >= 500) {
              notification.message = 'Internal server error, please try again later'
            } else if (err.info.status === 404) {
              notification.message = 'Server unavailable, please try again later'
            } else if (err.info.status === 401) {
              notification.message = 'Incorrect login or password'
            } else {
              notification.message = `${err.info.status}: ${err.info.statusText}`
            }
            this.addNotification({ notification })
          }
        })
    }
  }
}
</script>

<style lang="scss">
  [am-sing-in-row] {
    height: 100%;
    [am-error-field] {
      height: 15px;
      margin-top: 4px;
      .form-error li {
        display: none;
        &:first-child {
          display: block;
        }
      }
    }
  }
</style>
